import { useEffect } from 'react';
import { sendEvent } from '@chegg/rio2-web-client';
import {
  view_auth_page_client_pb as ViewAuthPageClient,
  view_experience_pb as ViewExperience,
  view_feature_pb as ViewFeature,
  view_property_pb as ViewProperty,
} from '@chegg/rio-event-schema-web';
import { sendRioEvent, updateRioState } from '../rio';
import Cookies from 'js-cookie';

/**
 * hook to send clickstreamview one time on page init
 */
export function useClickstreamView(view_name: string) {
  useEffect(() => {
    const view_version =
      Cookies.get('chegg_web_cbr_three_dot_o') &&
      Cookies.get('chegg_web_cbr_three_dot_o') === 'enabled'
        ? 'uae 1.0'
        : '';
    updateRioState({
      view: { view_name, experience: 'core', property: 'chegg', feature: 'auth', view_version },
    });
    sendRioEvent('clickstream_view', {});
  }, [view_name]);
}

/**
 * hook to send clickstreamview one time on page init
 */
export function useClickstreamViewRio2() {
  useEffect(() => {
    const eventData = new ViewAuthPageClient.ViewAuthPageClient();

    const currentView = {
      viewExperience: ViewExperience.ViewExperience.CORE,
      viewName: 'auth page',
      viewProperty: ViewProperty.ViewProperty.CHEGG,
      viewFeature: ViewFeature.ViewFeature.AUTH,
      viewVersion: '',
    };

    sendEvent('com.chegg.rio.poc.ViewAuthPageClient', eventData, currentView);
  }, []);
}
